import { Action } from 'redux';
import { IBackgroundJobInfo } from '../../../ts/resources/BackgroundJobs';
import { CancelBackgroundJob } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface CancelBackgroundJobAction extends Action {
    backgroundJob: IBackgroundJobInfo;
}

export function cancelBackgroundJobAction(backgroundJob: IBackgroundJobInfo): CancelBackgroundJobAction {
    return {
      type: CancelBackgroundJob,
      backgroundJob: backgroundJob
    };
  }

export const isCancelBackgroundJobAction = isActionFactory<CancelBackgroundJobAction>(CancelBackgroundJob);
